import Layout from "./components/Layout";
import LeftPanel from "./components/LeftPanel";
import RightPanel from "./components/RightPanel";

function App() {
  return (
    <Layout>
      <LeftPanel />
      <RightPanel />
    </Layout>
  );
}

export default App;
